import React from "react";

const Home = () => {
  return (
    <div>
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.2354 60.7997V51.0657C24.2354 48.5809 26.2502 46.5666 28.7356 46.5666H37.8208C39.0143 46.5666 40.159 47.0406 41.0029 47.8843C41.8469 48.7281 42.321 49.8725 42.321 51.0657V60.7997C42.3135 61.8328 42.7186 62.8261 43.4466 63.5592C44.1746 64.2924 45.1652 64.7047 46.1985 64.7047H52.3969C55.2917 64.7122 58.0706 63.5677 60.1203 61.5238C62.1699 59.48 63.3218 56.7047 63.3218 53.8105V26.0799C63.3217 23.742 62.2852 21.5243 60.4915 20.0244L39.4058 3.18795C35.7379 0.235944 30.4826 0.331257 26.9242 3.41432L6.31959 20.0244C4.4411 21.4801 3.31835 23.7043 3.26287 26.0799V53.7822C3.26287 59.8145 8.15414 64.7047 14.1878 64.7047H20.2447C22.3908 64.7047 24.1349 62.9736 24.1505 60.828L24.2354 60.7997Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export default Home;
